module.exports = __webpack_public_path__ + "img/photo03.b3b648af.jpg";